<template>
  
</template>

<script>
export default {
    props: {
        token: String,
        redirect: String,
    }, 
    methods: {
        auth() {
            this.$eventBus.$emit('loader:show')
            this.$store.dispatch('secure/AUTH', this.token)
            .then(res => {
                this.$router.replace({name: this.redirect, query: this.$route.query})
            })
            .catch(error => {
                this.$eventBus.$emit('error', error)
            })
            .finally(()=>{
                this.$eventBus.$emit('loader:hide')
            })
        }
    },
    created() {
        this.auth()
    }
}
</script>

<style>

</style>